import Card from "components/Card/Card";
import {
  GetPoListById,
  GetAllSuppliers,
  searchMedicationForPurchaseOrder,
  UpdatePurchaseOrder,
  RemoveAttachment,
  searchMedicationBarcodeForPurchaseOrder,
  getAllMedication,
  getuserbyid,
} from "Listfunction";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import Select from "react-select";
import AsyncSelect from "react-select/lib/Async";
import moment from "moment";
import NotificationSystem from "react-notification-system";
import Swal from "sweetalert2";
import { useReactToPrint } from "react-to-print";
import BarcodeInput from "./barcode";

import {
  Button,
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Grid,
  Table,
  Row,
  OverlayTrigger,
  Modal,
  Tooltip,
} from "react-bootstrap";
import Datetime from "react-datetime";
import { GetPurchaseOrderHistorydataSupplierWise } from "Listfunction";
import Collapsible from "react-collapsible";
import { CreateGoodsReturnNote } from "api/purchaseOrder/PurchaseOrder";
import { DeleteUrlPdf } from "api/purchaseOrder/PurchaseOrder";
import ScreenLoader from "views/Components/screenLoader";
import Checkbox from "components/CustomCheckbox/CustomCheckbox";
import AddMedicationModal from "./AddMedicationModal";
import { AddMedicationFromPO } from "api/purchaseOrder/PurchaseOrder";
import { getAvailableStock } from "api/purchaseOrder/PurchaseOrder";

const ForwardedFormControl = forwardRef((props, ref) => (
  <input {...props} ref={ref} />
));

const EditPoNew = (props) => {
  const _notificationSystem = React.createRef();
  const barcodenotification = <Tooltip id="remove">Generate Barcode</Tooltip>;

  const defaultPOItemValues = {
    id: moment().valueOf(),
    item: "",
    discription: "",
    item_code: "",
    batch_no: "",
    quantity: 0,
    price: "",
    discount: 0,
    free_of_goods: 0,
    account: 200,
    deals: "B2C",
    amount: 0,
    tax_rate: "tax",
    barcode: null,
    availableStock: 0,
    pack_size: 0,
    pack_price: 0,
    selling_price: 0,
  };

  // Preload all medications on mount (after functions are available)
  useEffect(() => {
    try {
      handleGetAllMedication();
    } catch (e) {
      // ignore
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [searchMedicineList, setSearchMedicineList] = useState([]);
  const [searchMedicineListData, setSearchMedicineListData] = useState();
  const [previousBarcode, setpreviousBarcode] = useState();
  const [previousPoId, setpreviousPoId] = useState();
  const [deliveryDate, setDeliveryDate] = useState();
  const [referance, setReference] = useState();
  const [barcodeShow, setBarcodeShow] = useState(false);
  const [note, setNote] = useState();
  const [supplierList, setSupplierList] = useState([]);
  const [poTotal, setPoTotal] = useState(0);
  const [supplierValue, setSupplierValue] = useState(setSupplierList[0]);
  const [poItemValues, setPoItemValues] = useState([defaultPOItemValues]);
  const [attachment, setAttachment] = useState([]);
  const [supplierError, setSupplierError] = useState(null);
  const [poId, setPoId] = useState();
  const [pdfUrl, setPdfUrl] = useState(null);
  const [attachmentError, setAttachmentError] = useState(null);
  const [goodReturnNoteUrls, setGoodReturnNoteUrls] = useState([]);
  const [addInvoiceNumber, setAddInvoiceNumber] = useState("");
  const [getMedicine, setGetMedicine] = useState("");
  const [medications, setMedications] = useState([]);
  const [rows, setRows] = useState([]);
  const [getDeliveryReason, setGetDeliveryReason] = useState("");
  const [otherOption, setOtherOption] = useState("");
  const [getGoodReturnValue, setGetGoodReturnValue] = useState([]);
  const [getDeliveryLeadTime, setGetDeliveryLeadTime] = useState("");
  const [getDeliveryLeadTimeBuffer, setGetDeliveryLeadTimeBuffer] =
    useState("");
  const [deliveryTimeError, setDeliveryTimeError] = useState(null);
  // const [isGoodReturnOpen, setIsGoodReturnOpen] = useState(false);
  const [poListDataById, setPoListDataById] = useState({
    supplier: 0,
    delivery_date: "",
    referance: "",
    items: [{ deals: "" }],
    item_code: "",
    name: "",
    discription: "",
    batch_no: "",
    quantity: null,
    price: "",
    discount: "",
    free_of_goods: 0,
    account: 200,
    amount: "",
    delivery_instructions: "",
    addInvoiceNumber,
    pack_size: 0,
    pack_price: 0,
    selling_price: 0,
  });
  const [supplierMobileNumber, setSupplierMobileNumber] = useState("");
  const [supplierEmail, setSupplierEmail] = useState("");
  const [purchaseOrderHistory, setPurchaseOrderHistory] = useState([]);
  const [purchaseOrderHistoryOrderItems, setPurchaseOrderHistoryOrderItems] =
    useState([]);
  const [POHistoryOrderItemsModalShow, setPOHistoryOrderItemsModalShow] =
    useState(false);
  const [addGRNModal, setAddGRNModal] = useState(false);
  const [returnPoItemValues, setReturnPoItemValues] = useState([
    {
      quantity: "",
      name: "",
      unitPrice: "",
      reason: "",
      isCheckDamageGoods: false,
      isCheckExcessGoods: false,
      isCheckWrongGoods: false,
    },
  ]);
  const [isGRNLoading, setIsGRNLoading] = useState(false);
  const [isCheckWrongGoods, setCheckWrongGoods] = useState(false);
  const [isCheckExcessGoods, setCheckExcessGoods] = useState(false);
  const [isCheckDamageGoods, setCheckDamageGoods] = useState(false);
  const [isCheckOtherReason, setCheckOtherReason] = useState(false);
  const [disableSubmitButton, setDisableSubmitButton] = useState(false);
  const [itemError, setItemError] = useState();
  // const [notificationSystem, setNotificationSystem] = useState(null);

  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMedicationCategory, setSelectedMedicationCategory] =
    useState(null);
  const [medicationName, setMedicationName] = useState(null);
  const [medicationModalCategoryError, setMedicationModalCategoryError] =
    useState(null);
  const [medicationModalNameError, setMedicationModalNameError] =
    useState(null);

  // Local draft persistence (per PO). Key will be `editPoDraft:<poId>`
  const DRAFT_KEY_BASE = "editPoDraft";
  const draftKey = () => (poId ? `${DRAFT_KEY_BASE}:${poId}` : null);

  const saveDraft = () => {
    try {
      if (!poId) return;
      const draft = {
        addInvoiceNumber,
        deliveryDate,
        referance,
        note,
        poItemValues,
        rows,
        getDeliveryReason,
        otherOption,
        poTotal,
        supplierValue,
        supplierMobileNumber,
        supplierEmail,
        getDeliveryLeadTime,
        getDeliveryLeadTimeBuffer,
        // timestamp to help determine recency when debugging/merging
        lastModified: Date.now(),
      };
      console.log("HELLO DRAFT", draft);
      localStorage.setItem(draftKey(), JSON.stringify(draft));
    } catch (e) {
      console.warn("Failed to save edit PO draft:", e);
    }
  };

  // Robust focus helper: defined at component scope so all handlers can use it.
  // Tries multiple times to focus/react-select menu to avoid calling focus on
  // null refs (prevents "Cannot read properties of null (reading 'focus')").
  const safeFocus = (target, attempts = 10, interval = 100) => {
    try {
      if (!target) return;
      let tries = 0;
      const runner = () => {
        try {
          if (!target) return;
          if (typeof target.focus === "function") {
            target.focus();
            return;
          }
          if (typeof target.onMenuOpen === "function") {
            target.onMenuOpen();
            return;
          }
          if (target.inputRef && typeof target.inputRef.focus === "function") {
            target.inputRef.focus();
            return;
          }
        } catch (e) {
          // swallow and retry
        }
        tries += 1;
        if (tries < attempts) setTimeout(runner, interval);
      };
      runner();
    } catch (e) {
      // ignore
    }
  };

  const inputRef = useRef(null);
  const barcodeRefs = useRef([]);

  const barcodeRef = useRef([]);

  // Local medication index and cache (for fast client-side search)
  const [localMedicationData, setLocalMedicationData] = useState([]);
  const medIndexRef = useRef([]);
  const medMapRef = useRef({});
  const medSearchCacheRef = useRef({});
  const medSearchRequestSeqRef = useRef(0);
  const loadMedTimerRef = useRef(null);

  // Initialize the hook at the top level of the component
  const handlePrint = useReactToPrint({
    content: () => {
      // The index will be set dynamically before calling this function
      return barcodeRef.current[handlePrint.index];
    },
  });
  const onPrintClick = (index) => {
    handlePrint.index = index; // Set the index before calling handlePrint
    handlePrint(); // Call the print function
  };
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;

  let medicationOption = [];

  // const accountDetails = [
  //   // { value: 0, label: "Select Account" },
  //   { value: 200, label: "Inventory" },
  //   { value: 425, label: "Freight courier" },
  //   { value: 311, label: "Cost of good" },
  //   { value: 313, label: "Sales Sample Cost" },
  //   { value: 203, label: "Discount Received" },
  //   { value: 860, label: "Rounding" },
  // ];

  const inputOnChange = async (event) => {
    // event.preventDefault();
    const val = event.target.value || "";
    setGetMedicine(val);

    // require at least 2 characters to reduce work
    if (!val || val.trim().length < 2) {
      setMedications([]);
      return;
    }

    const q = val.trim();

    // If we have a local medication index, search locally (fast)
    if (medIndexRef.current && medIndexRef.current.length > 0) {
      const lower = q.toLowerCase();
      const results = [];
      const LIMIT = 50;

      // 1) prefix matches
      for (
        let i = 0;
        i < medIndexRef.current.length && results.length < LIMIT;
        i++
      ) {
        const m = medIndexRef.current[i];
        if (m.labelLower.startsWith(lower)) results.push(m);
      }

      // 2) substring matches
      if (results.length < LIMIT) {
        for (
          let i = 0;
          i < medIndexRef.current.length && results.length < LIMIT;
          i++
        ) {
          const m = medIndexRef.current[i];
          if (results.indexOf(m) !== -1) continue;
          if (m.labelLower.includes(lower)) results.push(m);
        }
      }

      // 3) phonetic soundex fallback for longer queries
      if (results.length === 0 && lower.length >= 3) {
        const qSound = soundex(lower);
        for (
          let i = 0;
          i < medIndexRef.current.length && results.length < LIMIT;
          i++
        ) {
          const m = medIndexRef.current[i];
          if (m.soundex && m.soundex === qSound) results.push(m);
        }
      }

      // map to options used by existing UI (include data and unitPrice/qty)
      const options = results.map((m) => {
        const med = medMapRef.current[m.value] || {};
        return {
          value: med.item_code || m.value,
          label: m.label,
          data: med,
          unitPrice: med.unit_price,
          qty:
            med.total_quantity && med.total_allocated
              ? med.total_quantity - med.total_allocated
              : undefined,
        };
      });
      setMedications(options);
      return;
    }

    // fallback to server search when local index not available
    try {
      const res = await searchMedicationForPurchaseOrder(q, obj);
      res.data.data.map((item) => {
        if (
          !medicationOption.some((option) => option.value === item.item_code)
        ) {
          medicationOption.push({
            value: item.item_code,
            label: item.title + "(" + item.item_code + ")",
          });
        }
      });
      setSearchMedicineList(medicationOption);
      setSearchMedicineListData(res.data.data);
    } catch (e) {
      console.error("Medication search failed", e);
      setMedications([]);
    }
  };

  const sendToParent = async (val) => {
    const q = (val || "").trim();
    if (!q) return;

    // prefer local index if available
    if (medIndexRef.current && medIndexRef.current.length > 0) {
      const lower = q.toLowerCase();
      const results = [];
      const LIMIT = 50;

      for (
        let i = 0;
        i < medIndexRef.current.length && results.length < LIMIT;
        i++
      ) {
        const m = medIndexRef.current[i];
        if (m.labelLower.startsWith(lower)) results.push(m);
      }
      if (results.length < LIMIT) {
        for (
          let i = 0;
          i < medIndexRef.current.length && results.length < LIMIT;
          i++
        ) {
          const m = medIndexRef.current[i];
          if (results.indexOf(m) !== -1) continue;
          if (m.labelLower.includes(lower)) results.push(m);
        }
      }

      const options = results.map((m) => ({ value: m.value, label: m.label }));
      setSearchMedicineList(options);
      setSearchMedicineListData(
        results.map((r) => medMapRef.current[r.value] || {}),
      );
      return;
    }

    // fallback to server
    try {
      const res = await searchMedicationForPurchaseOrder(q, obj);
      res.data.data.map((item) => {
        if (
          !medicationOption.some((option) => option.value === item.item_code)
        ) {
          medicationOption.push({
            value: item.item_code,
            label: item.title,
          });
        }
      });
      setSearchMedicineList(medicationOption);
      setSearchMedicineListData(res.data.data);
    } catch (e) {
      console.error("sendToParent search failed", e);
    }
  };

  const showAddGRNModal = (id) => {
    setAddGRNModal(true);
  };
  const handleSelectChanges = (selectedOption, index) => {
    const duplicate = rows.some(
      (row, i) =>
        i !== index &&
        row.selectedOption &&
        row.selectedOption.value === selectedOption.value,
    );

    if (duplicate) {
      Swal.fire({
        width: " 478px",
        title:
          "<div style='font-size:26px;font-weight: 100;'>This medicine is already selected in another row!</div>",
        icon: "warning",
        showCloseButton: true,
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }
    const updatedRows = [...rows];
    updatedRows[index].selectedOption = selectedOption;
    updatedRows[index].unitPrice = selectedOption.unitPrice || "";
    setRows(updatedRows);
  };

  const handleAddMedication = async () => {
    if (!selectedMedicationCategory || !medicationName) {
      if (!selectedMedicationCategory) {
        setMedicationModalCategoryError("Please select a medication category.");
      }
      if (!medicationName) {
        setMedicationModalNameError("Please enter a medication name.");
      }
      return;
    }

    const newMedication = {
      title: medicationName,
      category_id: selectedMedicationCategory.value,
      price: 0,
      item_code: "",
      unit_price: 0,
      country: "1",
      isAvailable: "1",
      description: "",
      is_flash_medicine: "1",
      supplier_id: supplierValue ? supplierValue.value : null,
    };
    setIsLoading(true);
    const addNewMedication = await AddMedicationFromPO(newMedication, obj);
    setIsLoading(false);
    console.log(addNewMedication);
    if (addNewMedication && addNewMedication.data.success) {
      setMedicationModalCategoryError(null);
      setMedicationModalNameError(null);
      setSelectedMedicationCategory(null);
      setMedicationName("");
      setIsOpen(false);

      setPoItemValues((prev) => [
        ...prev,
        {
          id: moment().valueOf(),
          item: addNewMedication.data.data.item_code,
          name: `${addNewMedication.data.data.title} (${addNewMedication.data.data.item_code})`,
          account: 200,
          discription: "",
          amount: 0,
          item_code: addNewMedication.data.data.item_code,
          availableStock: 0,
          barcode: "",
          deals: "B2C",
          discount: 0,
          free_of_goods: 0,
          price: 0,
          quantity: 1,
          batch_no: "",
          tax_rate: "tax",
          pack_size: 0,
          pack_price: 0,
          selling_price: 0,
        },
      ]);

      // sendToParent(addNewMedication.data.data.item_code)
    } else {
      Swal.fire({
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight: 100;'>Failed to add medication. Please try again.</div>",
        icon: "error",
        showCloseButton: true,
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
    }
    console.log("Added Medication:", addNewMedication);
  };

  const handleGetDeliveryReason = (value) => {
    setGetDeliveryReason(value);
  };
  const handleRemoveValues = () => {
    setGetDeliveryReason(null);
    setOtherOption(null);
    setRows([]);
    // setIsGoodReturnOpen(false);
  };
  const handleInputChange = (inputValue) => {
    setGetMedicine(inputValue);

    if (inputValue.trim() !== "") {
      searchMedicationForPurchaseOrder(inputValue, obj)
        .then((res) => {
          if (res.success) {
            const selectedIds = rows
              .filter((row) => row.selectedOption)
              .map((row) => row.selectedOption.value);
            const options = res.data.data
              .filter((med) => !selectedIds.includes(med.id))
              .map((med) => ({
                value: med.id,
                label: `${med.medication_name} (${med.item_code})`,
                data: med,
                unitPrice: med.unit_price,
                qty: med.total_quantity - med.total_allocated,
              }));
            setMedications(options);
          }
        })
        .catch((err) => {
          console.error("Error fetching medications", err);
        });
    } else {
      setMedications([]);
    }
  };
  const handleQtyBlur = (e, index) => {
    let value = parseInt(e.target.value, 10);

    if (isNaN(value) || value < 1) {
      value = 1;
    }

    const updatedRows = [...rows];
    updatedRows[index].qty = value.toString();
    setRows(updatedRows);
  };
  const handleRemoveRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };
  const getEditUserData = () => {
    const supplierId = Number(
      supplierValue && supplierValue.value ? supplierValue.value : null,
    );
    if (!supplierId) return;
    getuserbyid(supplierId, obj)
      .then((res) => {
        const userId =
          (res && res.data && res.data.id) ||
          (res && res.data && res.data.data && res.data.data.id) ||
          supplierId;
        localStorage.setItem("CustomerID", JSON.stringify(userId));
        props.history.push("/admin/edit-user");
      })
      .catch((err) => {});
  };

  const handleQtyChanges = (e, index) => {
    const value = e.target.value;
    const updatedRows = [...rows];
    updatedRows[index].qty = value;
    updatedRows[index].touched = true;
    setRows(updatedRows);
  };
  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        selectedOption: null,
        //  description: "",
        qty: "1",
      },
    ]);
  };

  console.log(poItemValues);

  const sendToParentBulk = async (val, index) => {
    const res = await searchMedicationForPurchaseOrder(val, obj);

    res.data.data.map((item) => {
      if (!medicationOption.some((option) => option.value === item.item_code)) {
        medicationOption.push({
          value: item.item_code,
          label: item.title,
        });
      }
    });
    setSearchMedicineList(medicationOption);
    setSearchMedicineListData(res.data.data);
    // Do not auto-focus here. Only focus when a user explicitly adds a new row.
  };
  const sendToParentWhenBarcodeScanned = async (val, id, index) => {
    const res = await searchMedicationBarcodeForPurchaseOrder(val, obj);
    var dataValue = {};
    var selectedMedication = [];

    if (res.data.data.length == 1) {
      res.data.data.map((item) => {
        dataValue.value = item.item_code;
        dataValue.label = item.title;
        selectedMedication = item;
      });
      setPoItemValues((prev) => {
        const itemsDetails = prev.map((poItem) => {
          if (poItem.id === id) {
            return {
              ...poItem,
              item: dataValue.value,
              name: dataValue.label,
              price: Number(selectedMedication.unit_price),
              discription: selectedMedication.description,
              barcode: selectedMedication.barcode,
              amount: poItem.quantity * Number(selectedMedication.unit_price),
              item_code: selectedMedication.item_code,
            };
          }
          return poItem;
        });
        handleTotal(itemsDetails);
        return itemsDetails;
      });
    } else if (res.data.data.length != 0) {
      sendToParentBulk(val.trim(), index);
    }
  };

  // Build a simple phonetic code for loose matching (same as other forms)
  const soundex = (str) => {
    if (!str) return "";
    const s = str.toUpperCase().replace(/[^A-Z]/g, "");
    if (s.length === 0) return "";
    const first = s[0];
    const mapping = {
      B: "1",
      F: "1",
      P: "1",
      V: "1",
      C: "2",
      G: "2",
      J: "2",
      K: "2",
      Q: "2",
      S: "2",
      X: "2",
      Z: "2",
      D: "3",
      T: "3",
      L: "4",
      M: "5",
      N: "5",
      R: "6",
    };
    let prev = mapping[first] || "";
    let out = first;
    for (let i = 1; i < s.length && out.length < 4; i++) {
      const ch = s[i];
      const code = mapping[ch] || "0";
      if (code === prev) continue;
      if (code !== "0") {
        out += code;
      }
      prev = code;
    }
    return out.padEnd(4, "0").slice(0, 4);
  };

  const buildMedIndex = (medArray) => {
    try {
      medIndexRef.current = medArray.map((m) => {
        const label = `${m.title} (${m.item_code})`;
        const labelLower = (label || "").toLowerCase();
        let sdx = "";
        try {
          sdx = soundex(labelLower);
        } catch (e) {
          sdx = "";
        }
        return { value: m.item_code, label, labelLower, soundex: sdx };
      });
      // sort for stable prefix scanning
      medIndexRef.current.sort((a, b) =>
        a.labelLower > b.labelLower ? 1 : -1,
      );

      // build map for quick access to full medication objects
      const map = {};
      medArray.forEach((m) => {
        map[m.item_code] = m;
      });
      medMapRef.current = map;
    } catch (e) {
      medIndexRef.current = [];
      medMapRef.current = {};
    }
  };

  // Async loader for AsyncSelect: uses local medIndex when available,
  // otherwise falls back to server search. Debounced with simple timer.
  const loadMedicationOptions = (inputValue) => {
    if (!inputValue || inputValue.trim().length < 2) return Promise.resolve([]);
    const q = inputValue.trim();

    // return cached result
    if (medSearchCacheRef.current[q])
      return Promise.resolve(medSearchCacheRef.current[q]);

    // If medIndex exists, do local filtering immediately
    if (medIndexRef.current && medIndexRef.current.length > 0) {
      const lower = q.toLowerCase();
      const results = [];
      const LIMIT = 50;
      for (
        let i = 0;
        i < medIndexRef.current.length && results.length < LIMIT;
        i++
      ) {
        const m = medIndexRef.current[i];
        if (m.labelLower.startsWith(lower)) results.push(m);
      }
      if (results.length < LIMIT) {
        for (
          let i = 0;
          i < medIndexRef.current.length && results.length < LIMIT;
          i++
        ) {
          const m = medIndexRef.current[i];
          if (results.indexOf(m) !== -1) continue;
          if (m.labelLower.includes(lower)) results.push(m);
        }
      }
      if (results.length === 0 && lower.length >= 3) {
        const qSound = soundex(lower);
        for (
          let i = 0;
          i < medIndexRef.current.length && results.length < LIMIT;
          i++
        ) {
          const m = medIndexRef.current[i];
          if (m.soundex && m.soundex === qSound) results.push(m);
        }
      }
      const options = results.map((m) => ({ value: m.value, label: m.label }));
      try {
        const keys = Object.keys(medSearchCacheRef.current);
        if (keys.length > 200) delete medSearchCacheRef.current[keys[0]];
        medSearchCacheRef.current[q] = options;
      } catch (e) {}
      return Promise.resolve(options);
    }

    // Fallback: debounce and call server
    return new Promise((resolve) => {
      if (loadMedTimerRef.current) clearTimeout(loadMedTimerRef.current);
      loadMedTimerRef.current = setTimeout(() => {
        medSearchRequestSeqRef.current++;
        const reqSeq = medSearchRequestSeqRef.current;
        try {
          searchMedicationForPurchaseOrder(q, obj)
            .then((res) => {
              if (reqSeq !== medSearchRequestSeqRef.current) return resolve([]);
              const data = (res.data && res.data.data) || [];
              const options = data.map((medication) => ({
                value: medication.item_code,
                label: `${medication.title} (${medication.item_code})`,
              }));
              try {
                const keys = Object.keys(medSearchCacheRef.current);
                if (keys.length > 200)
                  delete medSearchCacheRef.current[keys[0]];
                medSearchCacheRef.current[q] = options;
              } catch (e) {}
              resolve(options);
            })
            .catch(() => resolve([]));
        } catch (e) {
          resolve([]);
        }
      }, 200);
    });
  };

  const handleGetAllMedication = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("user"));
      const auth = token ? token.token : null;
      const store = token && token.store_id ? token.store_id : 1;
      const res = await getAllMedication(auth, store);
      const mdata = res && res.data ? res.data : [];
      setLocalMedicationData(mdata);
      if (mdata && mdata.length > 0) buildMedIndex(mdata);
    } catch (e) {
      // ignore failures here - we will fallback to server search later
      console.warn("Failed to preload all medications:", e);
    }
  };

  // const handleSelectChange = (value, id) => {
  //   const selectedMedication =
  //     searchMedicineListData &&
  //     searchMedicineListData.find((Item) => value.value === Item.item_code);
  //   setPoItemValues((prev) => {
  //     const itemsDetails = prev.map((poItem) => {
  //       if (poItem.id === id) {
  //         if (selectedMedication.barcode != null) {
  //           return {
  //             ...poItem,
  //             item: value.value,
  //             name: value.label,
  //             price: Number(selectedMedication.buying_price),
  //             discription: selectedMedication.description,
  //             barcode: selectedMedication.barcode,
  //             amount: poItem.quantity * Number(selectedMedication.buying_price),
  //             item_code: selectedMedication.item_code,
  //             availableStock:
  //               Number(selectedMedication.total_quantity) -
  //               Number(selectedMedication.total_allocated),
  //             medicineError: null,
  //             unitPriceError: null,
  //           };
  //         } else {
  //           return {
  //             ...poItem,
  //             item: value.value,
  //             name: value.label,
  //             price: Number(selectedMedication.buying_price),
  //             discription: selectedMedication.description,
  //             //barcode: selectedMedication.barcode,
  //             amount: poItem.quantity * Number(selectedMedication.buying_price),
  //             item_code: selectedMedication.item_code,
  //             availableStock:
  //               Number(selectedMedication.total_quantity) -
  //               Number(selectedMedication.total_allocated),
  //           };
  //         }
  //       }
  //       return poItem;
  //     });
  //     handleTotal(itemsDetails);
  //     return itemsDetails;
  //   });
  //   setReturnPoItemValues((prev) => {
  //     const itemsDetails = prev.map((poItem) => {
  //       if (poItem.id === id) {
  //         if (selectedMedication.barcode != null) {
  //           return {
  //             ...poItem,
  //             item: value.value,
  //             name: value.label,
  //             price: Number(selectedMedication.buying_price),
  //             discription: selectedMedication.description,
  //             barcode: selectedMedication.barcode,
  //             amount: poItem.quantity * Number(selectedMedication.buying_price),
  //             item_code: selectedMedication.item_code,
  //           };
  //         } else {
  //           return {
  //             ...poItem,
  //             item: value.value,
  //             name: value.label,
  //             price: Number(selectedMedication.buying_price),
  //             discription: selectedMedication.description,
  //             //barcode: selectedMedication.barcode,
  //             amount: poItem.quantity * Number(selectedMedication.buying_price),
  //             item_code: selectedMedication.item_code,
  //           };
  //         }
  //       }
  //       return poItem;
  //     });
  //     handleTotal(itemsDetails);
  //     return itemsDetails;
  //   });
  //   setSearchMedicineList([]);
  // };

  // Active onChange handler for AsyncSelect (based on commented logic)
  const handleSelectChange = async (value, id) => {
    if (!value) return;
    // value.value is expected to be item_code
    const code = value.value;
    // Try local map first, fallback to searchMedicineListData
    const selectedMedication =
      (medMapRef.current && medMapRef.current[code]) ||
      (searchMedicineListData &&
        searchMedicineListData.find((Item) => code === Item.item_code));

    // If we found the medicine in local data, fetch available stock first
    let availableStockFromApi = 0;
    if (selectedMedication) {
      try {
        const StoreId = token.store_id;
        const availableStock = await getAvailableStock(
          selectedMedication.id,
          StoreId || "",
          obj,
        );
        availableStockFromApi = (availableStock && availableStock.data) || 0;
      } catch (error) {
        console.error("Error fetching available stock:", error);
      }
    }

    setPoItemValues((prev) => {
      const itemsDetails = prev.map((poItem) => {
        if (poItem.id === id) {
          const buyPrice = selectedMedication
            ? selectedMedication.buying_price
            : 0;
          const barcode =
            selectedMedication && selectedMedication.barcode != null
              ? selectedMedication.barcode
              : poItem.barcode;
          return {
            ...poItem,
            item: code,
            name: value.label,
            price: Number(buyPrice),
            discription: selectedMedication
              ? selectedMedication.description
              : poItem.discription,
            barcode: barcode,
            amount: poItem.quantity * Number(buyPrice || 0),
            item_code: code,
            availableStock: Number(availableStockFromApi) || 0,
            medicineError: null,
            unitPriceError: null,
          };
        }
        return poItem;
      });
      handleTotal(itemsDetails);
      return itemsDetails;
    });

    setReturnPoItemValues((prev) => {
      const itemsDetails = prev.map((poItem) => {
        if (poItem.id === id) {
          const buyPrice = selectedMedication
            ? selectedMedication.buying_price
            : 0;
          const barcode =
            selectedMedication && selectedMedication.barcode != null
              ? selectedMedication.barcode
              : poItem.barcode;
          return {
            ...poItem,
            item: code,
            name: value.label,
            price: Number(buyPrice),
            discription: selectedMedication
              ? selectedMedication.description
              : poItem.discription,
            barcode: barcode,
            amount: poItem.quantity * Number(buyPrice || 0),
            item_code: code,
          };
        }
        return poItem;
      });
      handleTotal(itemsDetails);
      return itemsDetails;
    });

    setSearchMedicineList([]);
  };
  console.log("poItemValues", poItemValues);
  const handleQtyChange = (event, id) => {
    const quantity = event.target.value;

    setPoItemValues((prev) => {
      const itemsDetails = prev.map((poItem) => {
        if (poItem.id === id) {
          const totalAmount = quantity * Number(poItem.price);
          const discountAmount = totalAmount * (poItem.discount / 100);
          const amountAfterDiscount = totalAmount - discountAmount;

          return {
            ...poItem,
            quantity: quantity,
            amount: amountAfterDiscount,
            qtyError: null,
          };
        }
        return poItem;
      });
      handleTotal(itemsDetails);
      return itemsDetails;
    });
  };

  const handleUnitPriceChange = (event, id) => {
    const uniPrice = event.target.value;

    setPoItemValues((prev) => {
      const itemsDetails = prev.map((poItem) => {
        if (poItem.id === id) {
          const totalAmount = uniPrice * poItem.quantity;
          const discountAmount = totalAmount * (poItem.discount / 100);
          const amountAfterDiscount = totalAmount - discountAmount;

          return {
            ...poItem,
            price: uniPrice,
            amount: amountAfterDiscount,
            unitPriceError: null,
          };
        }
        return poItem;
      });
      handleTotal(itemsDetails);
      return itemsDetails;
    });
  };

  const handlePackSizeChange = (event, id) => {
    const packSize = event.target.value;
    setPoItemValues((prev) =>
      prev.map((poItem) => {
        if (poItem.id === id) {
          return {
            ...poItem,
            pack_size: packSize,
            selling_price:
              poItem.pack_price && packSize
                ? Number(poItem.pack_price) / Number(packSize)
                : 0,
          };
        }
        return poItem;
      }),
    );
  };

  const handlePackPriceChange = (event, id) => {
    const packPrice = event.target.value;
    setPoItemValues((prev) =>
      prev.map((poItem) => {
        if (poItem.id === id) {
          return {
            ...poItem,
            pack_price: packPrice,
            selling_price:
              poItem.pack_size && packPrice
                ? Number(packPrice) / Number(poItem.pack_size)
                : 0,
          };
        }
        return poItem;
      }),
    );
  };

  const handleSellingPriceChange = (event, id) => {
    // const sellingPrice = event.target.value;
    setPoItemValues((prev) =>
      prev.map((poItem) => {
        if (poItem.id === id) {
          const sellingPrice =
            Number(poItem.pack_price) / Number(poItem.pack_size);
          return {
            ...poItem,
            selling_price: sellingPrice,
          };
        }
        return poItem;
      }),
    );
  };

  const handleGRNQtyChange = (e, index) => {
    const { value } = e.target;
    const updatedItems = [...returnPoItemValues];
    updatedItems[index].quantity = value;
    setReturnPoItemValues(updatedItems);
  };

  const handleGRNNameChange = (e, index) => {
    const { value } = e.target;
    const updatedItems = [...returnPoItemValues];
    updatedItems[index].name = value;
    setReturnPoItemValues(updatedItems);
  };

  const handleCheckboxChange = (index, field) => {
    const updatedItems = returnPoItemValues.map((item, i) =>
      i === index
        ? {
            ...item,
            isCheckWrongGoods:
              field === "isCheckWrongGoods" ? !item.isCheckWrongGoods : false,
            isCheckExcessGoods:
              field === "isCheckExcessGoods" ? !item.isCheckExcessGoods : false,
            isCheckDamageGoods:
              field === "isCheckDamageGoods" ? !item.isCheckDamageGoods : false,
            isCheckOtherReason:
              field === "isCheckOtherReason" ? !item.isCheckOtherReason : false,
          }
        : item,
    );
    setReturnPoItemValues(updatedItems);
  };

  const handleGRNReasonChange = (e, index) => {
    const { value } = e.target;
    const updatedItems = [...returnPoItemValues];
    updatedItems[index].reason = value;
    setReturnPoItemValues(updatedItems);
  };

  const handleGRNUnitPriceChange = (e, index) => {
    const { value } = e.target;
    const updatedItems = [...returnPoItemValues];
    updatedItems[index].unitPrice = value;
    setReturnPoItemValues(updatedItems);
  };
  const handleDiscountChange = (event, id) => {
    const discountValue = event.target.value;

    setPoItemValues((prev) => {
      const itemsDetails = prev.map((poItem) => {
        if (poItem.id === id) {
          const totalAmount = poItem.quantity * Number(poItem.price);
          const discountedAmount =
            totalAmount - (discountValue / 100) * totalAmount;
          return {
            ...poItem,
            discount: discountValue,
            amount: discountedAmount,
          };
        }
        return poItem;
      });
      handleTotal(itemsDetails);
      return itemsDetails;
    });
  };

  const handleFreeOfGoodChange = (event, id) => {
    const freeOfGood = event.target.value;

    setPoItemValues((prev) =>
      prev.map((poItem) => {
        if (poItem.id === id) {
          return {
            ...poItem,
            free_of_goods: freeOfGood,
          };
        }
        return poItem;
      }),
    );
  };

  const handleDescriptionChange = (event, id) => {
    const description = event.target.value;

    setPoItemValues((prev) =>
      prev.map((poItem) => {
        if (poItem.id === id) {
          return {
            ...poItem,
            discription: description,
          };
        }
        return poItem;
      }),
    );
  };

  const handleBatchNoChange = (event, id) => {
    const batch_no = event.target.value;

    setPoItemValues((prev) =>
      prev.map((poItem) => {
        if (poItem.id === id) {
          return {
            ...poItem,
            batch_no: batch_no,
          };
        }
        return poItem;
      }),
    );
  };
  const handleBarcodeChange = (event, id, index) => {
    const barcode = event.target.value;
    if (barcode.trim()[0] == "F") {
      if (barcode.length == 8) {
        if (previousPoId != id) {
          sendToParentWhenBarcodeScanned(barcode.trim(), id, index);
          setpreviousPoId(id);
          setpreviousBarcode(barcode);
        } else if (previousBarcode != barcode) {
          sendToParentWhenBarcodeScanned(barcode.trim(), id, index);
        }
      }
    } else {
      if (barcode.length == 7) {
        if (previousPoId != id) {
          sendToParentWhenBarcodeScanned(
            barcode.substring(1, 7).trim(),
            id,
            index,
          );
          setpreviousPoId(id);
          setpreviousBarcode(barcode);
        } else if (previousBarcode != barcode) {
          sendToParentWhenBarcodeScanned(
            barcode.substring(1, 7).trim(),
            id,
            index,
          );
        }
      }
    }

    setPoItemValues((prev) =>
      prev.map((poItem) => {
        if (poItem.id === id) {
          return {
            ...poItem,
            barcode: barcode,
          };
        }
        return poItem;
      }),
    );
  };

  // const handleAccountChange = (value, id) => {
  //   // const target = e.target;
  //   // const value = target.type === "select" ? target.selected : target.value;
  //   const accountValue = value;

  //   setPoItemValues((prev) =>
  //     prev.map((poItem) => {
  //       if (poItem.id === id) {
  //         return {
  //           ...poItem,
  //           account: accountValue,
  //           accountError: null,
  //         };
  //       }
  //       return poItem;
  //     })
  //   );
  // };

  const handleDeliveryDateChange = (value) => {
    const delivery_date = moment(value).format("YYYY-MM-DD");
    setDeliveryDate(delivery_date);
  };

  const handleReferenceChange = (event) => {
    const referenceValue = event.target.value;
    setReference(referenceValue);
  };

  const handleDeliveryInstructionChange = (event) => {
    const noteValue = event.target.value;
    setNote(noteValue);
  };
  const hanldeAddInvoiceNumber = (event) => {
    const addInvoiceNumbers = event.target.value;
    setAddInvoiceNumber(addInvoiceNumbers);
  };

  const handleDealsChange = (value, id) => {
    const dealsValue = value.value;

    setPoItemValues((prev) =>
      prev.map((poItem) => {
        if (poItem.id === id) {
          return {
            ...poItem,
            deals: dealsValue,
          };
        }
        return poItem;
      }),
    );
  };

  useEffect(() => {
    getEditUserData();
    const id = window.location.pathname.split("editPoNew/")[1];
    let supplierData = [];
    GetAllSuppliers(obj).then((res) => {
      const supplierOptions = res.data.data.map((supplier) => ({
        value: supplier.id,
        label: supplier.name,
      }));
      setSupplierList(supplierOptions);
      supplierData = res.data.data;
      // Try to reconcile a draft supplierValue (if draft exists) with the
      // freshly fetched supplierOptions so the Select shows the proper label.
      try {
        const key = `${DRAFT_KEY_BASE}:${id}`;
        const raw = localStorage.getItem(key);
        if (raw) {
          const d = JSON.parse(raw);
          // if (d && d.supplierValue) {
          //   console.log("AAAALLLOOKA", d);
          //   const sv = d.supplierValue;
          //   const match = supplierOptions.find(
          //     (s) =>
          //       String(s.value) === String(sv.value) ||
          //       String(s.value) === String(sv)
          //   );
          //   if (match) setSupplierValue(match);
          //   else setSupplierValue(sv);
          // }
        }
      } catch (e) {
        // ignore
      }
    });
    setPoId(id);

    // Try to load a local draft for this PO. If a draft exists and contains
    // poItemValues, prefer it and skip calling GetPoListById entirely.
    let draft = null;
    try {
      const key = `${DRAFT_KEY_BASE}:${id}`;
      const raw = localStorage.getItem(key);
      if (raw) draft = JSON.parse(raw);
    } catch (e) {
      console.warn("Failed to read edit PO draft:", e);
    }
    console.log("draft loaded:", draft);
    if (
      draft &&
      Array.isArray(draft.poItemValues) &&
      draft.poItemValues.length > 0
    ) {
      // load saved draft into state and skip server fetch
      if (draft.addInvoiceNumber) setAddInvoiceNumber(draft.addInvoiceNumber);
      if (draft.deliveryDate) setDeliveryDate(draft.deliveryDate);
      if (draft.referance) setReference(draft.referance);
      if (draft.note) setNote(draft.note);
      if (draft.poItemValues) setPoItemValues(draft.poItemValues);
      if (draft.rows) setRows(draft.rows);
      if (draft.getDeliveryReason)
        setGetDeliveryReason(draft.getDeliveryReason);
      if (draft.otherOption) setOtherOption(draft.otherOption);
      if (draft.poTotal) setPoTotal(draft.poTotal);
      if (draft.supplierMobileNumber)
        setSupplierMobileNumber(draft.supplierMobileNumber);
      if (draft.supplierEmail) setSupplierEmail(draft.supplierEmail);
      if (draft.getDeliveryLeadTime)
        setGetDeliveryLeadTime(draft.getDeliveryLeadTime);
      if (draft.getDeliveryLeadTimeBuffer)
        setGetDeliveryLeadTimeBuffer(draft.getDeliveryLeadTimeBuffer);
      if (draft.supplierValue) setSupplierValue(draft.supplierValue);
    } else {
      // No local draft with items; fetch server data as before
      GetPoListById(id, obj).then((res) => {
        setPoListDataById(res.data.data || []);
        const goodReturnNoteFiles = res.data.data.good_return_note_files || [];
        setGoodReturnNoteUrls(goodReturnNoteFiles);
        const defaultValues = res.data.data.items.map((data, index) => {
          const listId = moment().valueOf();
          // const account = accountDetails.find(
          //   (item) => item.value == data.account
          // );

          return {
            id: listId + index,
            item: data.item_code,
            discription: data.discription,
            batch_no: data.batch_no,
            barcode: !!data.barcode ? data.barcode : "",
            quantity: data.quantity,
            price: data.price,
            discount: data.discount,
            free_of_goods: data.free_of_goods,
            account: 200,
            deals: data.deals,
            amount: data.amount,
            tax_rate: "tax",
            name: data.name + data.item_code,
            item_code: data.item_code,
            availableStock: data.available_quantity || 0,
            pack_size: data.pack_size ? data.pack_size : 0,
            pack_price: data.pack_price ? data.pack_price : 0,
            selling_price: data.selling_price ? Number(data.selling_price) : 0,
          };
        });
        setPoItemValues(defaultValues);
        let total = 0;
        res.data.data.items.forEach((Item) => {
          total = total + Number(Item.amount);
        });
        setPoTotal(total);

        const supplier =
          supplierData &&
          supplierData.find((item) => item.id == res.data.data.supplier);
        if (supplier) {
          setSupplierValue({ value: supplier.id, label: supplier.name });
        } else {
          // If supplier not found in fetched supplier list, clear or set to raw id
          setSupplierValue(
            res.data.data.supplier
              ? {
                  value: res.data.data.supplier,
                  label: String(res.data.data.supplier),
                }
              : null,
          );
        }
        setDeliveryDate(res.data.data.delivery_date);
        setNote(res.data.data.delivery_instructions);
        setSupplierEmail(res.data.data.supplier_email);
        setGetDeliveryLeadTime(res.data.data.lead_time_days);
        setGetDeliveryLeadTimeBuffer(res.data.data.lead_time_days_buffer);
        setSupplierMobileNumber(res.data.data.supplier_mobile);
        setReference(res.data.data.referance);
        setAddInvoiceNumber(res.data.data.invoice_no);
        setGetGoodReturnValue(res.data.data.good_return);
        const goodReturnData = res.data.data.good_return || [];
        if (Array.isArray(goodReturnData) && goodReturnData.length > 0) {
          const reasonValue = goodReturnData[0].reason || "";
          if (reasonValue === "") {
            setGetDeliveryReason(null);
            setOtherOption("");
          } else if (
            reasonValue === "Wrong Goods" ||
            reasonValue === "Excess Goods" ||
            reasonValue === "Damage Goods"
          ) {
            setGetDeliveryReason({ value: reasonValue, label: reasonValue });
            setOtherOption("");
          } else {
            setGetDeliveryReason({ value: "Other", label: "Other" });
            setOtherOption(reasonValue);
          }
          const rowValues = goodReturnData.map((gr) => ({
            selectedOption: {
              label: gr.title,
              value: gr.title,
              qty: gr.quantity || "",
              unitPrice: gr.price || "",
            },
            qty: gr.quantity || "",
            unitPrice: gr.price || "",
          }));
          setRows(rowValues);
        }

        let temFileArray = [];
        res.data.data.files.forEach((file) => {
          fetch(file.url)
            .then((res) => res.blob())
            .then((blob) => {
              const filesFromApi = new File([blob], `${file.name}`, {
                type: blob.type,
              });
              temFileArray.push(filesFromApi);

              const fileArray = Array.from(temFileArray);

              const result = fileArray.map((file) => {
                file["isNewFile"] = false;
                return file;
              });
              setAttachment(result);
            });
        });
      });
    }

    return () => {
      setPoListDataById(null);
      setPoItemValues(null);
      setPoTotal(null);
      setSupplierValue(null);
      setReference(null);
      setDeliveryDate(null);
      setNote(null);
    };
  }, []);

  // Autosave draft whenever main form state changes (throttle not implemented)
  useEffect(() => {
    saveDraft();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    supplierValue,
    addInvoiceNumber,
    deliveryDate,
    referance,
    note,
    poItemValues,
    rows,
    getDeliveryReason,
    otherOption,
    getDeliveryLeadTime,
    getDeliveryLeadTimeBuffer,
  ]);

  // Reconcile supplierValue when supplierList changes (in case draft had supplier id only)
  useEffect(() => {
    try {
      if (!poId || !supplierList || supplierList.length === 0) return;
      const key = `${DRAFT_KEY_BASE}:${poId}`;
      const raw = localStorage.getItem(key);
      if (raw) {
        const d = JSON.parse(raw);
        // if (d && d.supplierValue) {
        //   const sv = d.supplierValue;
        //   const match = supplierList.find(
        //     (s) =>
        //       String(s.value) === String(sv.value) ||
        //       String(s.value) === String(sv)
        //   );
        //   if (match) setSupplierValue(match);
        // }
      }
    } catch (e) {
      // ignore
    }
  }, [supplierList, poId]);

  const handleButtonClick = (url) => {
    window.open(url, "_blank");
  };

  const handleAddClick = () => {
    setSearchMedicineList([]);
    setSearchMedicineListData([]);
    setPoItemValues((prev) => [
      ...prev,
      {
        ...defaultPOItemValues,
        id: moment().valueOf(),
        account: 200,
        deals: "B2C",
        quantity: 1,
      },
    ]);
    // Focus the newly added row's input after render. Use a short timeout so
    // refs have a chance to attach.
    setTimeout(() => {
      try {
        if (inputRef && inputRef.current && inputRef.current.length > 0) {
          const lastIndex = inputRef.current.length - 1;
          const el = inputRef.current[lastIndex];
          if (el) safeFocus(el, 15, 80);
        }
      } catch (err) {
        // ignore
      }
    }, 100);
  };

  const handleAddGRNReturnClick = () => {
    setSearchMedicineList([]);
    setSearchMedicineListData([]);
    setReturnPoItemValues((prev) => [
      ...prev,
      { ...returnPoItemValues, id: moment().valueOf() },
    ]);
  };
  // NOTE: removed automatic focusing when `poItemValues` changes. Focusing
  // now only occurs when the user clicks the Add button (see handleAddClick).

  const setBarcodeRef = (el, index) => {
    if (!barcodeRefs.current) {
      barcodeRefs.current = {};
    }
    barcodeRefs.current[index] = el;
  };

  const setBarcodeRefs = (el, index) => {
    if (!barcodeRef.current) {
      barcodeRef.current = {};
    }
    barcodeRef.current[index] = el;
  };

  const setInputRef = (el, index) => {
    // initialize as an array so length checks and numeric indices work as expected
    if (!inputRef.current) {
      inputRef.current = [];
    }
    inputRef.current[index] = el;
    // Intentionally do not auto-focus on ref attachment. Focusing should only
    // happen when the user clicks 'Add' (handled in handleAddClick).
  };

  const handleRemoveClick = (id) => {
    const poItems = [...poItemValues];
    const removeRow = poItems.filter((Item) => Item.id !== id);
    setPoItemValues(removeRow);

    handleTotal(removeRow);
    return removeRow;
  };

  const handleRemoveItemReturnClick = (id) => {
    const poItems = [...returnPoItemValues];
    const removeRow = poItems.filter((Item) => Item.id !== id);
    setReturnPoItemValues(removeRow);

    handleTotal(removeRow);
    return removeRow;
  };

  const onCloseModal = () => {
    setReturnPoItemValues([]);
    setAddGRNModal(false);
  };

  const handleRemoveAttachments = (name) => {
    const attachmentFile = [...attachment];
    let tempArray = [];
    tempArray.push(name);
    const fileArray = Array.from(tempArray);

    fileArray.map((file) => {
      if (file.isNewFile) {
        const removeFile = attachmentFile.filter((remove) => remove !== name);
        setAttachment(removeFile);
      } else {
        Swal.fire({
          width: "500px",
          title: "<strong><font size='36px'>Are Sure</font></strong>",
          icon: "info",
          html: "<font size='4px'>You want to remove this file permanently</font>",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: "<font size='4px'>Yes</font>",
          cancelButtonText: "<font size='4px'>No</font>",
        }).then(async (result) => {
          if (result.isConfirmed) {
            const notification = _notificationSystem.current;
            const files = file.name;
            const res = await RemoveAttachment(obj, poId, files);
            if (res.success === true) {
              notification.addNotification({
                title: <span data-notify="icon" className="pe-7s-gift"></span>,
                message: (
                  <div>
                    <b>Attachment</b> - Removed Successfully.
                  </div>
                ),
                level: "success",
                position: "bl",
                autoDismiss: 15,
              });
              const removeFile = attachmentFile.filter(
                (remove) => remove !== name,
              );
              setAttachment(removeFile);
            } else {
              notification.addNotification({
                title: <span data-notify="icon" className="pe-7s-gift"></span>,
                message: (
                  <div>
                    <b>{res.data}</b>
                  </div>
                ),
                level: "error",
                position: "bl",
                autoDismiss: 15,
              });
            }
          }
        });
      }
    });
  };

  const attachmentFileHandle = (event) => {
    const fileArray = Array.from(event.target.files).map((file) => file);
    const result = fileArray.map((file) => {
      file["isNewFile"] = true;
      return file;
    });

    setAttachment((prev) => [...prev, ...result]);
    setAttachmentError(null);
  };

  const uploadAttachment = () => {
    document.getElementById("attachment").click();
  };

  const handleOnSubmit = async () => {
    setSupplierError(null);
    const fdata = new FormData();
    fdata.append("supplier_id", supplierValue.value);
    if (deliveryDate !== null) {
      fdata.append("delivery_date", deliveryDate ? deliveryDate : "");
    }
    if (addInvoiceNumber !== null) {
      fdata.append("invoice_no", addInvoiceNumber);
    }
    if (referance !== null) {
      fdata.append("referance", !!referance ? referance : "");
    } else {
      fdata.append("referance", "");
    }
    if (referance !== null) {
      fdata.append("note", !!note ? note : "");
    } else {
      fdata.append("note", "");
    }
    if (attachment.length !== 0) {
      attachment.forEach((attach, index) => {
        if (attach.isNewFile === true) {
          fdata.append(`attachments[${index}]`, attach);
        } else {
          fdata.append(`attachments`, "");
        }
      });
    } else {
      fdata.append(`attachments`, "");
    }

    poItemValues.forEach((item, index) => {
      fdata.append(
        `order[${index}][item_code]`,
        item.item === undefined ? "" : item.item,
      );
      if (item.discription !== null) {
        fdata.append(`order[${index}][description]`, item.discription);
      }
      if (item.batch_no !== null) {
        fdata.append(`order[${index}][batch_no]`, item.batch_no);
      }
      if (item.barcode !== null && item.barcode !== undefined) {
        fdata.append(`order[${index}][barcode]`, item.barcode);
      }
      fdata.append(`order[${index}][quantity]`, Number(item.quantity));
      fdata.append(`order[${index}][price]`, item.price);
      if (item.deals !== null) {
        fdata.append(`order[${index}][deals]`, "B2C");
      } else {
        fdata.append(`order[${index}][deals]`, "");
      }
      fdata.append(`order[${index}][discount]`, Number(item.discount));
      fdata.append(`order[${index}][tax_rate]`, item.tax_rate);
      fdata.append(`order[${index}][account]`, 200);
      fdata.append(
        `order[${index}][free_of_goods]`,
        item.free_of_goods === null ? 0 : Number(item.free_of_goods),
      );
      fdata.append(`order[${index}][pack_size]`, item.pack_size);
      fdata.append(`order[${index}][pack_price]`, item.pack_price);
      fdata.append(`order[${index}][selling_price]`, item.selling_price);
    });
    rows.forEach((row, index) => {
      fdata.append(
        `good_return[${index}][title]`,
        row.selectedOption ? row.selectedOption.label : "",
      );
      fdata.append(
        `good_return[${index}][price]`,
        row.unitPrice ? parseFloat(row.unitPrice).toFixed(2) : "0.00",
      );
      fdata.append(`good_return[${index}][quantity]`, parseInt(row.qty) || 0);
      fdata.append(
        `good_return[${index}][reason]`,
        getDeliveryReason && getDeliveryReason.value === "Other"
          ? otherOption
          : (getDeliveryReason && getDeliveryReason.value) || "",
      );
    });

    const notification = _notificationSystem.current;
    try {
      // save latest snapshot before submitting
      saveDraft();
    } catch (e) {
      // ignore
    }
    setDisableSubmitButton(true);
    setIsLoading(true);
    const res = await UpdatePurchaseOrder(fdata, obj, poId);
    setDisableSubmitButton(false);
    setIsLoading(false);
    if (res.success === true) {
      !!notification &&
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>PO</b> - Added Successfully .
            </div>
          ),
          level: "success",
          position: "bl",
          autoDismiss: 15,
        });
      // clear draft on successful update
      try {
        const key = draftKey();
        if (key) localStorage.removeItem(key);
      } catch (e) {
        // ignore
      }
      props.history.push("/admin/poList");
    } else if (res.message === "You Cannot Edit this Purchase order") {
      Swal.fire({
        icon: "error",
        title: `<strong><font size='36px'>${res.message}</font></strong>`,
      });
    } else {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>{res.message}</b>
          </div>
        ),
        level: "error",
        position: "bl",
        autoDismiss: 15,
      });
    }
  };
  const isGeneratePDFDisabled =
    !returnPoItemValues.every(
      (poItem) =>
        poItem.unitPrice &&
        poItem.unitPrice.length > 0 &&
        poItem.quantity &&
        poItem.quantity.length > 0 &&
        poItem.name &&
        poItem.name.length > 0,
    ) || !returnPoItemValues.length;
  const handleGRNonSubmit = async () => {
    setIsGRNLoading(true);
    const notification = _notificationSystem.current;

    try {
      const goodsReturnNoteBody = {
        items: returnPoItemValues.map((item) => ({
          quantity: item.quantity,
          name: item.name,
          unitPrice: item.unitPrice,
          reason: item.isCheckWrongGoods
            ? "Wrong good"
            : item.isCheckDamageGoods
              ? "Damage goods"
              : item.isCheckExcessGoods
                ? "Excess goods"
                : item.reason,
        })),
      };
      const createReturnNote = await CreateGoodsReturnNote(
        obj,
        goodsReturnNoteBody,
        poId,
      );

      const returnNotePDF = createReturnNote.data.data.pdf_url;
      if (returnNotePDF) {
        window.open(returnNotePDF, "_blank");
        setPdfUrl(returnNotePDF);
        GetPoListById(poId, obj).then((res) => {
          const goodReturnNoteFiles =
            res.data.data.good_return_note_files || [];
          setGoodReturnNoteUrls(goodReturnNoteFiles);
        });
      } else {
        notification.addNotification({
          title: <span data-notify="icon">PDF URL not found</span>,
          message: <div>Something went wrong</div>,
          level: "warning",
          position: "bl",
          autoDismiss: 15,
        });
      }
    } catch (error) {
      console.error("Error downloading purchase order:", error);
      notification.addNotification({
        title: (
          <span data-notify="icon">Error downloading purchase order:</span>
        ),
        message: <div>Something went wrong</div>,
        level: "warning",
        position: "bl",
        autoDismiss: 15,
      });
    } finally {
      setIsGRNLoading(false);
      setReturnPoItemValues([]);
      setAddGRNModal(false);
    }
  };

  const handleTotal = (items) => {
    let total = 0;
    const poItem = [...items];
    poItem.forEach((Item) => {
      total = total + Item.amount;
    });
    setPoTotal(total);
  };

  const handleSupplierChange = (value) => {
    const supplier = value;
    setSupplierValue(supplier);
  };
  const handleCLick = () => {
    let error = false;
    const isMandatoryFieldsFilled = poItemValues.filter(
      (data) =>
        !data.account ||
        data.account === 0 ||
        Number(data.quantity) === 0 ||
        data.quantity === "" ||
        data.price === "" ||
        Number(data.price) === 0 ||
        !data.item ||
        data.item === "",
    );
    if (supplierValue === undefined) {
      error = true;
      setSupplierError(
        <small className="text-danger">Supplier is required.</small>,
      );
    }
    if (poItemValues.length === 0) {
      error = true;
      setItemError(
        <div class="alert alert-danger" role="alert">
          Please Add atleast one item
        </div>,
      );
    }
    if (getDeliveryLeadTime == null || getDeliveryLeadTime == "") {
      error = true;
      setDeliveryTimeError(
        <div class="alert alert-danger" role="alert">
          Please create a Delivery Lead Time
        </div>,
      );
    }
    if (isMandatoryFieldsFilled.length > 0) {
      error = true;
      const isMandatoryFieldsFilledError = poItemValues.map((data) => {
        let poItem = {
          ...data,
        };
        if (!data.account || data.account === 0) {
          poItem = {
            ...poItem,
            accountError: (
              <small className="text-danger">feild required.</small>
            ),
          };
        }
        if (Number(data.quantity) === 0 || data.quantity == "") {
          poItem = {
            ...poItem,
            qtyError: <small className="text-danger">feild required.</small>,
          };
        }
        if (data.price == "" || Number(data.price) == 0) {
          poItem = {
            ...poItem,
            unitPriceError: (
              <small className="text-danger">feild required.</small>
            ),
          };
        }
        if (data.item == "" || !data.item) {
          poItem = {
            ...poItem,
            medicineError: (
              <small className="text-danger">feild required.</small>
            ),
          };
        }
        return poItem;
      });
      setPoItemValues(isMandatoryFieldsFilledError);
    }
    if (!error) {
      Swal.fire({
        width: "500px",
        title: "<strong><font size='36px'>Are Sure</font></strong>",
        icon: "info",
        html: "<font size='4px'>You want to save this changes</font>",
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: "<font size='4px'>Yes</font>",
        cancelButtonText: "<font size='4px'>No</font>",
      }).then((result) => {
        if (result.isConfirmed) {
          handleOnSubmit();
        }
      });
    }
  };
  const DeletePdfUrlGrn = (pdfUrl, index) => {
    if (!pdfUrl) {
      Swal.fire({
        width: "500px",
        icon: "warning",
        title: "<strong><font size='36px'>Sorry!</font></strong>",
        html: "<font size='4px'>No PDF available.</font>",
        confirmButtonText: "<font size='4px'>OK</font>",
      });
      return;
    }

    Swal.fire({
      width: "500px",
      title: "<strong><font size='36px'>Are you sure?</font></strong>",
      icon: "warning",
      html: "<font size='4px'>You want to delete this PDF</font>",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "<font size='4px'>Yes</font>",
      cancelButtonText: "<font size='4px'>No</font>",
    }).then((result) => {
      if (result.isConfirmed) {
        DeleteUrlPdf(poId, pdfUrl, obj)
          .then((res) => {
            if (res && res.status === 200) {
              Swal.fire({
                width: "500px",
                icon: "success",
                title: "<strong><font size='36px'>Deleted</font></strong>",
                html: "<font size='4px'>PDF URL has been deleted</font>",
                confirmButtonText: "<font size='4px'>OK</font>",
                timer: 2000,
                showConfirmButton: true,
              }).then(() => {
                const updatedUrls = goodReturnNoteUrls.filter(
                  (url, i) => i !== index,
                );
                setGoodReturnNoteUrls(updatedUrls);
              });
            }
          })
          .catch((err) => {
            Swal.fire({
              width: "500px",
              icon: "error",
              title: "<strong><font size='36px'>Error</font></strong>",
              html: "<font size='4px'>Failed to delete the PDF URL</font>",
              timer: 2000,
              showConfirmButton: false,
            });
          });
      } else {
        Swal.fire({
          width: "500px",
          icon: "info",
          title: "<strong><font size='36px'>Cancelled</font></strong>",
          html: "<font size='4px'>PDF URL was not deleted</font>",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    });
  };

  // const VieWGrnPdfClicked = () => {
  //   if (pdfUrl) {
  //     window.open(pdfUrl, "_blank");
  //   } else {
  //     Swal.fire({
  //       width: "500px",
  //       icon: "error",
  //       title: "<strong><font size='36px'>PDF Not Available</font></strong>",
  //       confirmButtonText: "<font size='4px'>OK</font>",
  //     });
  //   }
  // };

  const showPOHistoryData = () => {
    GetPurchaseOrderHistorydataSupplierWise(supplierValue, obj).then((res) => {
      setPurchaseOrderHistory(res.data.data);
    });
  };
  const handleTotalPOAmount = (poHistoryItems) => {
    let totalAmountForPoHistory = 0;
    const total = poHistoryItems.forEach((data) => {
      totalAmountForPoHistory = Number(data.amount) * Number(data.quantity);
    });
    return totalAmountForPoHistory;
  };
  const showPoItemsModal = (POHistoryOrderItems, id) => {
    setPurchaseOrderHistoryOrderItems(POHistoryOrderItems);
    setPOHistoryOrderItemsModalShow(true);
  };

  const handlePOHistoryItemTotal = (orderItem) => {
    let total = 0;
    orderItem.forEach((Item) => {
      total =
        total +
        (Number(Item.amount) * Number(Item.quantity) -
          (Number(Item.discount) / 100) *
            (Number(Item.amount) * Number(Item.quantity)));
    });
    return total.toFixed(2);
  };
  const view = <Tooltip id="view">View PO items</Tooltip>;
  const edit = <Tooltip id="edit">Edit Email</Tooltip>;
  return (
    <>
      {isLoading && <ScreenLoader />}
      <Grid fluid>
        <NotificationSystem ref={_notificationSystem} />
        <br />
        <Card
          content={
            <>
              <div> {itemError}</div>
              <div>{!getDeliveryLeadTime && deliveryTimeError}</div>
              <form>
                <div className="table-responsive">
                  <Table
                    style={{ border: "none !important" }}
                    className="fl_order_details"
                  >
                    <thead>
                      <tr>
                        <th align="center" style={{ paddingLeft: 0 }}>
                          <ControlLabel>Supplier</ControlLabel>
                        </th>
                        <th align="center" style={{ paddingLeft: 0 }}>
                          <ControlLabel>Invoice Number</ControlLabel>
                        </th>
                        <th align="center" style={{ paddingLeft: 0 }}>
                          <ControlLabel>Delivery Date</ControlLabel>
                        </th>
                        <th align="center" style={{ paddingLeft: 0 }}>
                          <ControlLabel>Reference</ControlLabel>
                        </th>
                        <th align="center" style={{ paddingLeft: 0 }}>
                          <ControlLabel>Attachment</ControlLabel>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ verticalAlign: "top" }}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "10px",
                            }}
                          >
                            <FormGroup style={{ marginBottom: 0 }}>
                              <Select
                                className="react-select primary"
                                name="supplier"
                                value={supplierValue}
                                onChange={(value) =>
                                  handleSupplierChange(value)
                                }
                                options={supplierList}
                                placeholder="Select Supplier"
                              />
                              {supplierValue !== undefined
                                ? null
                                : supplierError}
                            </FormGroup>
                            {supplierValue && (
                              <>
                                {getDeliveryLeadTime ? (
                                  <span
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: "bold",
                                      border: "2px solid #a0a8a0",
                                      borderRadius: "5px",
                                      color: "#6e6d6d",
                                      padding: "8px 12px",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      width: "fit-content",
                                    }}
                                  >
                                    Delivery Within{" "}
                                    {Number(getDeliveryLeadTime) +
                                      Number(getDeliveryLeadTimeBuffer)}{" "}
                                    days &nbsp;
                                    <i className="fas fa-shipping-fast" />
                                  </span>
                                ) : (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "flex-start",
                                      gap: "6px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        border: "2px solid #a0a8a0",
                                        borderRadius: "5px",
                                        color: "#6e6d6d",
                                        padding: "8px 12px",
                                      }}
                                    >
                                      Lead Time Not Added
                                    </span>
                                    <a
                                      onClick={getEditUserData}
                                      style={{
                                        color: "blue",
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                      }}
                                    >
                                      Click Here To Create
                                    </a>
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                        </td>
                        <td style={{ verticalAlign: "top" }}>
                          <FormGroup style={{ marginBottom: 0 }}>
                            <FormControl
                              className="form-control"
                              placeholder="Enter Po Number"
                              type="text"
                              rows="4"
                              cols="5"
                              name="addInvoiceNumber"
                              onChange={(e) => hanldeAddInvoiceNumber(e)}
                              value={addInvoiceNumber}
                            />
                          </FormGroup>
                        </td>
                        <td style={{ verticalAlign: "top" }}>
                          <FormGroup style={{ marginBottom: 0 }}>
                            <Datetime
                              timeFormat={false}
                              dateFormat="YYYY-MM-DD"
                              inputProps={{ placeholder: "Delivery Date" }}
                              value={deliveryDate}
                              closeOnSelect={true}
                              onChange={(value) =>
                                handleDeliveryDateChange(value)
                              }
                            />
                          </FormGroup>
                        </td>
                        <td style={{ verticalAlign: "top" }}>
                          <FormGroup style={{ marginBottom: 0 }}>
                            <FormControl
                              type="text"
                              name="reference"
                              defaultValue={referance}
                              placeholder="Reference "
                              onChange={(e) => handleReferenceChange(e)}
                            />
                          </FormGroup>
                        </td>
                        <td style={{ verticalAlign: "top" }}>
                          <Button
                            onClick={() => uploadAttachment()}
                            style={{
                              color: "#2B3A41",
                              marginTop: "5px",
                            }}
                          >
                            {" "}
                            <i
                              className={
                                attachment === undefined
                                  ? "fa fa-plus"
                                  : "fa fa-pencil fa-fw"
                              }
                            ></i>{" "}
                            {attachment == ""
                              ? "Choose Attachment"
                              : "Change Attachment"}
                          </Button>
                          <input
                            style={{ display: "none" }}
                            id="attachment"
                            type="file"
                            className="form-control"
                            name="attachment"
                            multiple
                            onChange={attachmentFileHandle}
                          />
                          <br />
                          <br />
                          {attachmentError}
                        </td>
                      </tr>
                      <tr>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>
                          {" "}
                          {attachment !== ""
                            ? attachment.map((name, index) => (
                                <>
                                  <span
                                    style={{
                                      background: "black",
                                      color: "white",
                                      padding: "10px",
                                    }}
                                    key={index}
                                  >
                                    <a
                                      href={URL.createObjectURL(name)}
                                      target="_blank"
                                    >
                                      {name.name}
                                    </a>
                                    <img
                                      onClick={() =>
                                        handleRemoveAttachments(name)
                                      }
                                      style={{
                                        padding: "5px",
                                        background: "transparent",
                                        cursor: "pointer",
                                        width: "20px",
                                        alignSelf: "flex-start",
                                      }}
                                      src="https://img.icons8.com/ios-glyphs/30/FFFFFF/delete-sign.png"
                                      alt="remove"
                                    />
                                  </span>
                                  <br />
                                  <br />
                                </>
                              ))
                            : null}
                        </td>
                      </tr>
                    </tbody>
                    <thead>
                      <tr>
                        <th align="center" style={{ paddingLeft: 0 }}>
                          <ControlLabel>Supplier Mobile No.</ControlLabel>
                        </th>
                        <th align="center" style={{ paddingLeft: 0 }}>
                          <ControlLabel>Supplier Email</ControlLabel>
                        </th>
                        <th align="center" style={{ paddingLeft: 0 }}></th>
                        <th>
                          <ControlLabel>Good Return Note</ControlLabel>
                        </th>
                        <th>
                          <ControlLabel>GRN PDF</ControlLabel>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <FormGroup>
                            <FormControl
                              disabled
                              type="text"
                              name="supplierMobileNumber"
                              placeholder="Supplier mobile number "
                              value={supplierMobileNumber}
                            />
                          </FormGroup>
                        </td>
                        <td>
                          <FormGroup>
                            <FormControl
                              disabled
                              type="text"
                              name="supplierEmail"
                              placeholder="Supplier email "
                              value={supplierEmail}
                            />
                          </FormGroup>
                        </td>
                        {/* <td>
                          
                        </td> */}
                        <td>
                          <OverlayTrigger placement="top" overlay={edit}>
                            <Button
                              simple
                              // bsStyle="info"
                              bsSize="sm"
                              onClick={getEditUserData}
                            >
                              {" "}
                              <i className="fas fa-edit" />
                            </Button>
                          </OverlayTrigger>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          <span
                            style={{
                              verticalAlign: "top",
                              padding: "21px 0px 0px 10px",
                            }}
                          >
                            <Button
                              className="btn btn-fill"
                              onClick={() => showAddGRNModal()}
                            >
                              <i
                                className={"fa fa-reply"}
                                style={{ marginRight: "5px" }}
                              ></i>{" "}
                              <>Add GRN</>
                            </Button>
                          </span>
                        </td>
                        <td>
                          {goodReturnNoteUrls.map((url, index) => (
                            <div
                              key={index}
                              style={{
                                position: "relative",
                                display: "inline-block",
                                margin: "5px",
                                paddingbottom: "3px",
                              }}
                            >
                              <Button
                                onClick={() => handleButtonClick(url)}
                                style={{ color: "red" }}
                              >
                                <i
                                  style={{
                                    fontSize: "19px",
                                    color: "red",
                                  }}
                                  className="fa fa-file-pdf"
                                ></i>{" "}
                                &nbsp; View PDF {index + 1}
                              </Button>
                              <i
                                className="fa fa-close"
                                onClick={() => DeletePdfUrlGrn(url, index)}
                                style={{
                                  position: "absolute",
                                  top: "-5px",
                                  right: "-5px",
                                  cursor: "pointer",
                                  fontSize: "12px",
                                  color: "black",
                                  background: "white",
                                  borderRadius: "50%",
                                  padding: "3px",
                                }}
                              ></i>
                            </div>
                          ))}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
                <hr />
                {/* {!!supplierValue && (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        // alignItems: "end",
                        marginRight: "25px",
                        textAlign: "right",
                        justifyContent: "end",
                        
                      }}
                    >
                      <Button
                        style={{ marginLeft: "15px" }}
                        className="btn btn-fill"
                        onClick={() => setIsOpen(true)}
                      >
                        <i
                          className="fa fa-plus"
                          style={{ marginRight: "5px" }}
                        ></i>{" "}
                        Add Medicine
                      </Button>
                    </div>
                    <br />
                  </>
                )} */}
                <div>
                  <table
                    // className="fl_order_details"
                    style={{
                      overflow: "auto",
                      borderCollapse: "separate",
                      borderSpacing: "10px 0",
                      width: "100%",
                    }}
                  >
                    <thead
                      style={{
                        position: "sticky",
                        top: 0,
                        background: "#ffffff",
                        zIndex: 1000,
                      }}
                    >
                      <tr>
                        <th style={{ textAlign: "center" }}>
                          <ControlLabel>&nbsp;</ControlLabel>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <ControlLabel>Barcode</ControlLabel>
                        </th>
                        <th style={{ paddingLeft: 0 }}>
                          <ControlLabel>Item</ControlLabel>
                        </th>
                        {/* <th style={{ textAlign: "center" }}>
                          <ControlLabel>Description</ControlLabel>
                        </th> */}
                        {/* <th style={{ textAlign: 'center' }}>
    <ControlLabel>B: No</ControlLabel>
  </th> */}
                        <th style={{ textAlign: "center" }}>
                          <ControlLabel>Qty</ControlLabel>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <ControlLabel>Unit Price</ControlLabel>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <ControlLabel>Discount</ControlLabel>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <ControlLabel>Free</ControlLabel>
                        </th>
                        {/* <th style={{ textAlign: "center" }}>
                          <ControlLabel>Account</ControlLabel>
                        </th> */}
                        {/* <th style={{ textAlign: "center" }}>
                          <ControlLabel>Deals</ControlLabel>
                        </th> */}

                        <th style={{ textAlign: "center" }}>
                          <ControlLabel>Pack Size</ControlLabel>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <ControlLabel>Pack Price</ControlLabel>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <ControlLabel>Selling Price</ControlLabel>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <ControlLabel>Amount</ControlLabel>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {poItemValues &&
                        poItemValues.map((poItem, index) => (
                          <tr style={{ verticalAlign: "top" }}>
                            <td style={{ width: "5%" }}>
                              <FormGroup>
                                <FormControl
                                  type="text"
                                  name="serial_no"
                                  placeholder="S.No"
                                  value={index + 1}
                                  disabled
                                />
                              </FormGroup>
                            </td>
                            <td style={{ width: "10%" }}>
                              <FormGroup>
                                <ForwardedFormControl
                                  type="text"
                                  name="barcode"
                                  placeholder="Barcode"
                                  style={{
                                    backgroundColor: "#ffffff",
                                    border: "1px solid #e3e3e3",
                                    borderRadius: "4px",
                                    color: "#565656",
                                    padding: " 8px 12px",
                                    height: "40px",
                                    boxShadow: "none",
                                    width: "100%",
                                  }}
                                  onChange={(e) =>
                                    handleBarcodeChange(e, poItem.id, index)
                                  }
                                  ref={(el) =>
                                    !!poItem.barcode && setBarcodeRef(el, index)
                                  }
                                  value={
                                    !!poItem.barcode
                                      ? poItem.barcode
                                      : poItem.item_code
                                  }
                                />
                              </FormGroup>
                            </td>
                            <td style={{ width: "25%", paddingTop: "5px" }}>
                              <FormGroup>
                                <div className="Appy">
                                  <AsyncSelect
                                    className="react-select primary"
                                    classNamePrefix="react-select"
                                    name="item"
                                    loadOptions={loadMedicationOptions}
                                    onChange={(value) =>
                                      handleSelectChange(value, poItem.id)
                                    }
                                    placeholder="Medication Name"
                                    ref={(ref) => setInputRef(ref, index)}
                                    value={{
                                      value: poItem.item,
                                      label: poItem.name,
                                    }}
                                    noOptionsMessage={() => "Type Item Name"}
                                  />
                                </div>
                              </FormGroup>
                              <FormGroup style={{ marginTop: "-5px" }}>
                                <FormControl
                                  type="text"
                                  name="description"
                                  placeholder="Description "
                                  onChange={(e) =>
                                    handleDescriptionChange(e, poItem.id)
                                  }
                                  value={
                                    poItem.discription === null
                                      ? ""
                                      : poItem.discription
                                  }
                                />
                              </FormGroup>
                              {!!poItem.medicineError && poItem.medicineError}
                            </td>
                            <td style={{ width: "8%" }}>
                              <span>
                                <FormGroup>
                                  <FormControl
                                    type="number"
                                    name="qty"
                                    min={1}
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Quantity "
                                    value={poItem.quantity}
                                    onChange={(e) =>
                                      handleQtyChange(e, poItem.id)
                                    }
                                  />
                                </FormGroup>
                                {!!poItem.qtyError && poItem.qtyError}
                                <p
                                  style={{
                                    marginLeft: "10px",
                                    fontSize: "12px",
                                    color: "rgb(255, 138, 38)",
                                  }}
                                >
                                  Available Stock{" "}
                                  {Number(poItem.availableStock)}
                                </p>
                              </span>
                            </td>
                            <td style={{ width: "8%" }}>
                              <FormGroup>
                                <FormControl
                                  type="text"
                                  name="unit_price"
                                  placeholder="Unit Price "
                                  value={
                                    poItem.price === null
                                      ? ""
                                      : poItem.price || ""
                                  }
                                  onChange={(e) =>
                                    handleUnitPriceChange(e, poItem.id)
                                  }
                                  onWheel={(e) => e.target.blur()}
                                />
                              </FormGroup>
                              {!!poItem.unitPriceError && poItem.unitPriceError}
                            </td>
                            <td style={{ width: "4%" }}>
                              <FormGroup>
                                <FormControl
                                  type="number"
                                  name="discount"
                                  placeholder="Discount "
                                  onChange={(e) =>
                                    handleDiscountChange(e, poItem.id)
                                  }
                                  value={poItem.discount}
                                />
                              </FormGroup>
                            </td>
                            <td style={{ width: "4%" }}>
                              <FormGroup>
                                <FormControl
                                  type="number"
                                  name="free_of_good"
                                  placeholder="Free of goods"
                                  onWheel={(e) => e.target.blur()}
                                  onChange={(e) =>
                                    handleFreeOfGoodChange(e, poItem.id)
                                  }
                                  value={poItem.free_of_goods}
                                />
                              </FormGroup>
                            </td>
                            {/* <td style={{ width: "10%", paddingTop: "5px" }}>
                              <FormGroup>
                                <Select
                                  className="react-select primary"
                                  classNamePrefix="react-select"
                                  name="account"
                                  placeholder="Account"
                                  options={accountDetails}
                                  value={poItem.account}
                                  onChange={(value) =>
                                    handleAccountChange(value, poItem.id)
                                  }
                                />
                              </FormGroup>
                              {!!poItem.accountError && poItem.accountError}
                            </td> */}
                            {/* <td style={{ width: "10%", paddingTop: "5px" }}>
                              <FormGroup>
                                <Select
                                  className="react-select primary"
                                  classNamePrefix="react-select"
                                  name="deals"
                                  value={
                                    poItem.deals === null
                                      ? ""
                                      : {
                                          value: poItem.deals,
                                          label: poItem.deals,
                                        }
                                  }
                                  placeholder="Deals"
                                  options={[
                                    { value: "B2B", label: "B2B" },
                                    { value: "B2C", label: "B2C" },
                                    { value: "None", label: "None" },
                                  ]}
                                  onChange={(value) =>
                                    handleDealsChange(value, poItem.id)
                                  }
                                />
                              </FormGroup>
                            </td> */}
                            <td style={{ width: "8%" }}>
                              <FormGroup>
                                <FormControl
                                  type="number"
                                  name="pack_size"
                                  placeholder="Pack Size "
                                  value={poItem.pack_size || ""}
                                  onChange={(e) =>
                                    handlePackSizeChange(e, poItem.id)
                                  }
                                  onWheel={(e) => e.target.blur()}
                                />
                              </FormGroup>
                            </td>
                            <td style={{ width: "8%" }}>
                              <FormGroup>
                                <FormControl
                                  type="number"
                                  name="pack_price"
                                  placeholder="Pack Price "
                                  value={poItem.pack_price || ""}
                                  onChange={(e) =>
                                    handlePackPriceChange(e, poItem.id)
                                  }
                                  onWheel={(e) => e.target.blur()}
                                />
                              </FormGroup>
                            </td>
                            <td style={{ width: "8%" }}>
                              <FormGroup>
                                <FormControl
                                  type="number"
                                  name="selling_price"
                                  placeholder="Selling Price "
                                  value={
                                    poItem.selling_price
                                      ? `${poItem.selling_price.toFixed(4)}`
                                      : ""
                                  }
                                  disabled
                                  onWheel={(e) => e.target.blur()}
                                  onChange={(e) =>
                                    handleSellingPriceChange(e, poItem.id)
                                  }
                                />
                              </FormGroup>
                            </td>
                            <td style={{ width: "10%" }}>
                              <FormGroup>
                                <FormControl
                                  type="number"
                                  name="amount"
                                  placeholder="Amount "
                                  value={
                                    poItem.amount
                                      ? poItem.amount.toFixed(4)
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </td>
                            <td>
                              <Button
                                onClick={() => handleRemoveClick(poItem.id)}
                                style={{ border: "none", marginBottom: "10px" }}
                              >
                                <i
                                  class="fa fa-times-circle"
                                  aria-hidden="true"
                                ></i>
                              </Button>
                            </td>
                            {poItem.item_code &&
                            (poItem.barcode !== null
                              ? poItem.barcode.trim()[0] == "F"
                              : true) ? (
                              <>
                                <td>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={barcodenotification}
                                  >
                                    <Button
                                      onClick={() => onPrintClick(index)}
                                      style={{
                                        border: "none",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <i
                                        class="fa fa-barcode"
                                        aria-hidden="true"
                                      ></i>
                                    </Button>
                                  </OverlayTrigger>
                                </td>
                                <td style={{ display: "none" }}>
                                  <div
                                    ref={(ref) => setBarcodeRefs(ref, index)}
                                    className="print-only"
                                  >
                                    <BarcodeInput
                                      name={poItem.name}
                                      itemcode={poItem.item_code}
                                    />
                                  </div>
                                </td>
                              </>
                            ) : (
                              ""
                            )}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>

                <Button onClick={() => handleAddClick()}>Add New Line</Button>
                <Button
                  style={{ marginLeft: "15px" }}
                  className="btn btn-fill"
                  onClick={() => setIsOpen(true)}
                >
                  <i className="fa fa-plus" style={{ marginRight: "5px" }}></i>{" "}
                  Add New Medicine
                </Button>
                <Row>
                  <div
                    style={{
                      display: "flex",
                      float: "right",
                      marginRight: "100px",
                      gap: "40px",
                    }}
                  >
                    <div>
                      <h5>
                        <b>Total</b>
                      </h5>
                    </div>
                    <div>
                      <h5>{Number(poTotal).toFixed(4)}</h5>
                    </div>
                  </div>
                </Row>
                <hr />
                <Row>
                  <Col md={12} xs={12} sm={12} lg={12}>
                    {/* <div
                      className="collapeablecomp_orderhistory"
                      style={{
                        backgroundColor: "#D7FFDB",
                        padding: "10px",
                        borderRadius: "5px",
                        marginBottom: "15px",
                      }}
                    >
                      <Collapsible
                        trigger="Good Return Note"
                        transitionTime={200}
                        open={isGoodReturnOpen}
                      > */}
                    <div
                      style={{
                        background: "#EEEEEE",
                        padding: "10px",
                        borderRadius: "10px",
                      }}
                    >
                      <h3>Good Return Note</h3>
                      <br />
                      <Button
                        style={{ float: "right" }}
                        className="btn btn-fill btn btn-default"
                        onClick={handleRemoveValues}
                      >
                        Clear
                      </Button>
                      <div
                        style={{
                          display: "flex",
                          gap: "20px",
                        }}
                      >
                        <Select
                          name="getDeliveryReason"
                          value={getDeliveryReason}
                          placeholder="Search Status"
                          onChange={handleGetDeliveryReason}
                          options={[
                            { value: "Wrong Goods", label: "Wrong Goods" },
                            { value: "Excess Goods", label: "Excess Goods" },
                            { value: "Damage Goods", label: "Damage Goods" },
                            { value: "Other", label: "Other" },
                          ]}
                          styles={{
                            container: (base) => ({
                              ...base,
                              width: "220px",
                            }),
                          }}
                        />
                        {getDeliveryReason &&
                        getDeliveryReason.value === "Other" ? (
                          <textarea
                            style={{ width: "20%" }}
                            className="form-control"
                            value={otherOption}
                            name="otherOption"
                            onChange={(e) => setOtherOption(e.target.value)}
                            placeholder="Enter other reason"
                          ></textarea>
                        ) : (
                          ""
                        )}
                      </div>
                      <br />
                      <Col md={12} style={{ marginBottom: "5px" }}>
                        <div className="table-responsive">
                          <Table
                            style={{
                              width: "100%",
                            }}
                          >
                            <thead>
                              <tr>
                                <th
                                  style={{
                                    width: "30%",
                                    textAlign: "center",
                                  }}
                                >
                                  <ControlLabel>Medicine Name</ControlLabel>
                                </th>

                                <th
                                  style={{
                                    width: "30%",
                                    textAlign: "center",
                                  }}
                                >
                                  <ControlLabel>Unit Price</ControlLabel>
                                </th>
                                <th
                                  style={{
                                    width: "30%",
                                    textAlign: "center",
                                  }}
                                >
                                  <ControlLabel>Quantity</ControlLabel>
                                </th>
                                {/* <th style={{ textAlign: "center" }}></th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {rows.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan={4}
                                    style={{ textAlign: "center" }}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "sans-serif",
                                        textAlign: "center",
                                        fontSize: "13px",
                                        fontWeight: 100,
                                      }}
                                    >
                                      {" "}
                                      No medication added
                                    </span>
                                  </td>
                                </tr>
                              ) : (
                                rows.map((row, index) => (
                                  <tr key={index}>
                                    <td style={{ width: "30%" }}>
                                      <Select
                                        placeholder="Search medicine"
                                        value={
                                          row.selectedOption &&
                                          row.selectedOption.label &&
                                          row.selectedOption.value
                                            ? row.selectedOption
                                            : null
                                        }
                                        onChange={(selected) =>
                                          handleSelectChanges(selected, index)
                                        }
                                        onInputChange={(inputValue) =>
                                          handleInputChange(inputValue)
                                        }
                                        options={medications}
                                        isClearable
                                        isSearchable
                                        noOptionsMessage={() => "No results"}
                                      />
                                    </td>
                                    <td style={{ width: "30%" }}>
                                      <FormControl
                                        isDisabled
                                        placeholder="Unit Price"
                                        value={row.unitPrice}
                                        readOnly
                                      />
                                    </td>
                                    <td style={{ width: "30%" }}>
                                      <FormControl
                                        name="qty"
                                        value={row.qty}
                                        type="number"
                                        min="1"
                                        placeholder="Enter Quantity"
                                        onWheel={(e) => e.target.blur()}
                                        onBlur={(e) => handleQtyBlur(e, index)}
                                        onChange={(e) =>
                                          handleQtyChanges(e, index)
                                        }
                                      />
                                    </td>
                                    <td>
                                      <a
                                        href="javascript:void(0)"
                                        onClick={() => handleRemoveRow(index)}
                                      >
                                        X
                                      </a>
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                      <div style={{ textAlign: "center" }}>
                        <Button
                          className="btn btn-default"
                          style={{ marginTop: "10px" }}
                          onClick={handleAddRow}
                        >
                          <i className="fa fa-plus"></i> Add Medicine
                        </Button>
                      </div>
                    </div>
                    {/* </Collapsible>
                    </div> */}
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col md={12} xs={12} sm={12}>
                    <ControlLabel>Delivery Instruction</ControlLabel>

                    <textarea
                      className="form-control"
                      rows="4"
                      cols="5"
                      name="note"
                      onChange={(e) => handleDeliveryInstructionChange(e)}
                      value={note}
                    />
                  </Col>
                </Row>
                <br />
                <br />
                {supplierValue && (
                  <Row>
                    <Col md={12} xs={12} sm={12}>
                      <div
                        className="collapeablecomp_orderhistory"
                        style={{
                          backgroundColor: "#D7FFDB",
                          padding: "10px",
                          borderRadius: "5px",
                        }}
                      >
                        <Collapsible
                          trigger="PO History"
                          transitionTime={200}
                          onOpen={() => {
                            showPOHistoryData();
                          }}
                        >
                          <Table responsive>
                            <thead>
                              <tr>
                                <th>PO ID</th>
                                <th>Name</th>
                                <th>Order Date</th>
                                <th>Total Cost</th>
                                <th className="text-right">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {purchaseOrderHistory &&
                              purchaseOrderHistory.length === 0 ? (
                                <tr>
                                  <td colspan="10">
                                    <center>No record found</center>
                                  </td>
                                </tr>
                              ) : (
                                <React.Fragment>
                                  {purchaseOrderHistory &&
                                    purchaseOrderHistory.map(
                                      (poHistory, key) => (
                                        <tr key={key}>
                                          <td>{poHistory.id}</td>
                                          <td>{poHistory.supplier.name}</td>
                                          {/* <td>{lastd.opharma_reference}</td> */}
                                          <td>{poHistory.created_at}</td>
                                          <td>
                                            {handlePOHistoryItemTotal(
                                              poHistory.order_items,
                                            )}
                                          </td>
                                          <td className="text-right">
                                            {" "}
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={view}
                                            >
                                              <Button
                                                simple
                                                bsStyle="info"
                                                onClick={() => {
                                                  showPoItemsModal(
                                                    poHistory.order_items,
                                                    poHistory.id,
                                                  );
                                                }}
                                                bsSize="sm"
                                              >
                                                <i className="fa fa-user" />
                                              </Button>
                                            </OverlayTrigger>
                                          </td>
                                        </tr>
                                      ),
                                    )}
                                </React.Fragment>
                              )}
                            </tbody>
                          </Table>
                        </Collapsible>
                      </div>
                    </Col>
                  </Row>
                )}
                <br />
                <Row>
                  <Col>
                    <Button
                      class="btn-color"
                      onClick={() => handleCLick()}
                      disabled={disableSubmitButton}
                      fill
                    >
                      Submit
                    </Button>
                  </Col>
                </Row>
              </form>
            </>
          }
        />
        <Modal
          show={POHistoryOrderItemsModalShow}
          onHide={() => {
            setPOHistoryOrderItemsModalShow(false);
            setPurchaseOrderHistoryOrderItems([]);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Medication Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <p key={1}>
              {" "}
              TotalCost : {(handleTotalPOAmount(purchaseOrderHistoryOrderItems)).toFixed(2)}
            </p> */}

            <Table>
              <thead>
                <tr>
                  <th>Medication</th>
                  <th>Unit Price</th>
                  <th>Quantity</th>
                  <th>Discount %</th>
                  <th>Free of goods</th>
                </tr>
              </thead>
              <tbody>
                {purchaseOrderHistoryOrderItems &&
                  purchaseOrderHistoryOrderItems.map((data) => (
                    <tr key={data.medication_id}>
                      <td>{data.medicine.title}</td>
                      <td>{Number(data.amount - 0).toFixed(2)}</td>
                      <td>{data.quantity}</td>
                      <td>{Number(data.discount)}</td>
                      <td>{data.free_of_goods}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Modal.Body>
        </Modal>
        <Modal
          show={addGRNModal}
          onHide={() => {
            setAddGRNModal(false);
          }}
          bsSize="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Good Return Note</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "0px 15px" }}>
            <div style={{ padding: "5px" }} className="table-responsive">
              <Table className="fl_order_details" style={{ overflow: "auto" }}>
                <thead
                  style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "white",
                    zIndex: 1000,
                  }}
                >
                  <tr>
                    <th style={{ textAlign: "center" }}>
                      <ControlLabel>Item Name</ControlLabel>
                    </th>
                    <th style={{ textAlign: "center" }}>
                      <ControlLabel>Qty</ControlLabel>
                    </th>
                    <th style={{ textAlign: "center" }}>
                      <ControlLabel>Unit Price</ControlLabel>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {returnPoItemValues &&
                    returnPoItemValues.map((poItem, index) => (
                      <tr key={index}>
                        <td style={{ width: "25%", verticalAlign: "top" }}>
                          <FormGroup>
                            <FormControl
                              type="text"
                              name="name"
                              min={1}
                              placeholder="Enter return item name"
                              onChange={(e) => handleGRNNameChange(e, index)}
                              value={poItem.name}
                            />
                          </FormGroup>
                          <div>
                            <ControlLabel>Reason for return</ControlLabel>
                          </div>
                          <div style={{ alignItems: "center" }}>
                            <label style={{ alignItems: "center" }}>
                              <input
                                name={`poItemRadio-${index}`} // Unique name for each item group
                                type="radio"
                                checked={poItem.isCheckWrongGoods || false}
                                onChange={() =>
                                  handleCheckboxChange(
                                    index,
                                    "isCheckWrongGoods",
                                  )
                                }
                              />
                              <span style={{ marginLeft: "8px" }}>
                                Wrong goods
                              </span>
                            </label>
                            &nbsp;&nbsp;&nbsp;
                            <label style={{ alignItems: "center" }}>
                              <input
                                name={`poItemRadio-${index}`} // Same name for grouping
                                type="radio"
                                checked={poItem.isCheckExcessGoods || false}
                                onChange={() =>
                                  handleCheckboxChange(
                                    index,
                                    "isCheckExcessGoods",
                                  )
                                }
                              />
                              <span style={{ marginLeft: "8px" }}>
                                Excess goods
                              </span>
                            </label>
                            &nbsp;&nbsp;&nbsp;
                            <label style={{ alignItems: "center" }}>
                              <input
                                name={`poItemRadio-${index}`} // Same name for grouping
                                type="radio"
                                checked={poItem.isCheckDamageGoods || false}
                                onChange={() =>
                                  handleCheckboxChange(
                                    index,
                                    "isCheckDamageGoods",
                                  )
                                }
                              />
                              <span style={{ marginLeft: "8px" }}>
                                Damage goods
                              </span>
                            </label>
                            &nbsp;&nbsp;&nbsp;
                            <label style={{ alignItems: "center" }}>
                              <input
                                name={`poItemRadio-${index}`}
                                type="radio"
                                checked={poItem.isCheckOtherReason || false}
                                onChange={() =>
                                  handleCheckboxChange(
                                    index,
                                    "isCheckOtherReason",
                                  )
                                }
                              />
                              <span style={{ marginLeft: "8px" }}>Other</span>
                            </label>
                            &nbsp;&nbsp;&nbsp;
                          </div>

                          {poItem.isCheckOtherReason && (
                            <FormGroup style={{ marginLeft: "5px" }}>
                              <FormControl
                                style={{
                                  margin: 0,
                                  width: "100%",
                                  padding: "5px",
                                  // fontSize: "11px",
                                  height: "50px",
                                  border: "1px solid #e3e3e3",
                                  borderRadius: "4px",
                                  color: "#565656",
                                  resize: "none",
                                  outline: "none",
                                  backgroundColor: "#ffffff",
                                }}
                                name="reason"
                                onChange={(e) =>
                                  handleGRNReasonChange(e, index)
                                }
                                placeholder="Enter other reason"
                                value={poItem.reason}
                                rows={4}
                              />
                            </FormGroup>
                          )}
                        </td>
                        <td style={{ width: "8%", verticalAlign: "top" }}>
                          <FormGroup>
                            <FormControl
                              type="number"
                              name="quantity"
                              min={1}
                              placeholder="Qty"
                              onChange={(e) => handleGRNQtyChange(e, index)}
                              value={poItem.quantity}
                            />
                          </FormGroup>
                        </td>
                        <td style={{ width: "10%", verticalAlign: "top" }}>
                          <FormGroup>
                            <FormControl
                              type="number"
                              name="unitPrice"
                              placeholder="Unit Price"
                              value={poItem.unitPrice}
                              onChange={(e) =>
                                handleGRNUnitPriceChange(e, index)
                              }
                            />
                          </FormGroup>
                        </td>

                        <td style={{ width: "5%", verticalAlign: "top" }}>
                          <Button
                            onClick={() =>
                              handleRemoveItemReturnClick(poItem.id)
                            }
                            style={{ border: "none", marginBottom: "10px" }}
                          >
                            <i
                              className="fa fa-times-circle"
                              aria-hidden="true"
                            ></i>
                          </Button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "5px",
              }}
            >
              <Button onClick={handleAddGRNReturnClick}>
                <i className="fa fa-plus"></i> Add Medicine
              </Button>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => handleGRNonSubmit()}
              bsStyle="success"
              fill
              disabled={isGeneratePDFDisabled}
            >
              Generate PDF
            </Button>
            <Button bsStyle="danger" fill onClick={() => onCloseModal()}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </Grid>
      {isGRNLoading && <ScreenLoader />}
      {isOpen && (
        <AddMedicationModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          selectedMedicationCategory={selectedMedicationCategory}
          setSelectedMedicationCategory={setSelectedMedicationCategory}
          medicationName={medicationName}
          setMedicationName={setMedicationName}
          handleAddMedication={handleAddMedication}
          medicationModalCategoryError={medicationModalCategoryError}
          medicationModalNameError={medicationModalNameError}
          setMedicationModalCategoryError={setMedicationModalCategoryError}
          setMedicationModalNameError={setMedicationModalNameError}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      )}
    </>
  );
};

export default EditPoNew;
